<template>
  <el-tabs type="border-card">
    <el-tab-pane :style="getStyle">
      <span slot="label">
        <em class="el-icon-tickets"></em>
        {{ $t('common_words.general_information2') }}
      </span>
      <p class="justify-paragraph fs-14 mt-2 mb-1">
        {{ $t('common_words.selected_record_info') }}
      </p>
      <slot name="info"></slot>
    </el-tab-pane>
    <!-- <el-tab-pane v-if="isSuper() || isAdmin()" label="Auditoría">
      <span slot="label"> <em class="el-icon-timer"></em> Auditoría </span>
    </el-tab-pane> -->
  </el-tabs>
</template>
<script>
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  name: 'content-show-dialog',
  props: {
    fullHeight: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    getStyle() {
      if (this.fullHeight)
        return 'min-height: calc(100vh - 11vh); overflow-y: auto';
      return '';
    },
  },
  mixins: [MixinPermissions],
};
</script>
